import { Fragment } from 'react'

import type { LegalBlock, LegalSection } from './legalSection'

interface LegalDocumentBodyProps {
  sections: LegalSection[]
}

/**
 * Рендерер юридических документов в кабинете.
 *
 * Текст приходит данными, сгенерированными из markdown, — тем же, из которого собираются
 * страницы на лендинге. Раньше оферта жила прямо в TSX и правилась руками, из-за чего кабинет
 * показывал редакцию, отличную от опубликованной.
 */
export const LegalDocumentBody = ({ sections }: LegalDocumentBodyProps) => (
  <>
    {sections.map((section) => (
      <section key={section.id} id={section.id}>
        <h2>{section.title}</h2>
        {section.blocks.map((block, index) => (
          <LegalBlockView key={`${section.id}-${index}`} block={block} />
        ))}
      </section>
    ))}
  </>
)

const LegalBlockView = ({ block }: { block: LegalBlock }) => {
  if (block.type === 'ul') {
    return (
      <ul>
        {block.items.map((item) => (
          <li key={item}>
            <Linkified text={item} />
          </li>
        ))}
      </ul>
    )
  }
  return (
    <p>
      <Linkified text={block.text} />
    </p>
  )
}

// Адреса и почта в тексте — кликабельные: документ читают, чтобы найти, куда писать.
const LINK_PATTERN = /(https?:\/\/[^\s,;)]+[^\s.,;)]|[\w.+-]+@[\w-]+\.[\w.-]+)/g

const Linkified = ({ text }: { text: string }) => {
  const parts = text.split(LINK_PATTERN)
  return (
    <>
      {parts.map((part, index) => {
        if (index % 2 === 0) return <Fragment key={index}>{part}</Fragment>
        const href = part.includes('@') ? `mailto:${part}` : part
        return (
          <a
            key={index}
            href={href}
            {...(href.startsWith('http') ? { target: '_blank', rel: 'noreferrer' } : {})}
          >
            {part}
          </a>
        )
      })}
    </>
  )
}
